
import { getEmailRules } from '@/utils/Utils';
import { uploadPdfDocument } from '@/utils/pdf/PdfDocumentRepository';
import clone from 'clone';
import { Component, Ref, Vue } from "vue-property-decorator";
import { ProjectDetails } from "../../../data/models/ProjectDetails";
import { COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK } from '@/utils/colors';
import { themed } from "@/utils/Theme";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component
export default class ClientDataSectionDialogComponent extends Vue {
  isShowing = false;
  isEditMode = false;

  emailRules = getEmailRules(this.$t("common.invalidEmailAddress").toString());

  resolve?: (value: ProjectDetails | undefined) => void = undefined;
  reject?: (reason: string) => void = undefined;

  projectDetails: ProjectDetails = {} as ProjectDetails;

  file: File | null = null;
  
  initialFileName: string | null = null;
  fileName: string | null = null;

  title = "";

  @Ref("confirm") confirmDialog!: ConfirmationDialogComponent;

  /** Returns the title with " bearbeiten" suffix when in edit mode. */
  get displayTitle(): string {
    return this.isEditMode ? `${this.title} ${this.$t('common.edit').toString().toLowerCase()}` : this.title;
  }

  async showDialog(title: string, projectDetails: ProjectDetails) {
    this.projectDetails = projectDetails

    this.title = title;
    this.isEditMode = !this.hasInitialData();
    if (this.isEditMode) {
      this.takeSnapshot();
    }
    this.isShowing = true;

    return new Promise<ProjectDetails | undefined>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  updateProjectDetails(projectDetails: ProjectDetails) {
    //hack to force refresh
    this.isShowing = false;
    this.projectDetails = clone(projectDetails)
    this.isShowing = true;
  }

  /** Override in subclasses to check if any fields have existing data. */
  hasInitialData(): boolean {
    return false;
  }

  /** Override in subclasses to capture current field values for change detection. */
  takeSnapshot(): void {
    // override in subclasses
  }

  /** Override in subclasses to compare current values against snapshot. */
  get hasChanged(): boolean {
    return false;
  }

  onEdit() {
    this.isEditMode = true;
    this.takeSnapshot();
  }

  async onCancelEdit() {
    if (this.hasChanged) {
      const result = await this.confirmDialog.show({
        title: this.$t("common.confirmationDialog.unsavedChangesTitle").toString(),
        message: this.$t("common.confirmationDialog.unsavedChangesMessage").toString(),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.$t("common.abort").toString(),
      });
      if (!result) return;
    }
    this.isEditMode = false;
    this.isShowing = false;
    this.resolve && this.resolve(undefined);
  }

  onAccept() {
    this.isShowing = false;

    if (this.file && this.projectDetails.pdfDocument) {
      if (this.fileName && this.initialFileName !== this.fileName) {
        uploadPdfDocument(this.fileName, this.file);
      }
    }

    this.resolve && this.resolve(this.projectDetails);
  }

  onReject() {
    this.isShowing = false;
    this.resolve && this.resolve(undefined);
  }

  onInput() {
    if (this.isEditMode) return;
    this.resolve && this.resolve(undefined);
  }

  get style() {
    return `background: ${themed(COLOR_BASE_DIALOG_BACKGROUND, COLOR_BASE_DIALOG_BACKGROUND_DARK)}`;
  }
}
